import clsx from 'clsx';
import { Card, CardActions, CardContent, CardHeader, styled } from '@mui/material';

export interface DetailsSectionWrapperProps {
	className?: string;
	classes?: {
		header?: string;
		content?: string;
	};
	title?: React.ReactNode;
	subheader?: React.ReactNode;
	avatar?: React.ReactNode;
	headerAction?: React.ReactNode;
	children?: React.ReactNode;
	actions?: React.ReactNode;
	disablePadding?: boolean;
}

function DetailsSectionWrapper(props: DetailsSectionWrapperProps) {
	return (
		<Card variant="outlined" className={clsx(props.className, 'rounded-8')}>
			{props.title && (
				<CardHeader
					classes={{
						root: props.classes?.header,
						title: 'text-13 font-600',
						avatar: 'my-8 mr-12 self-baseline',
						action: 'm-0 self-center'
					}}
					avatar={props.avatar}
					title={props.title}
					subheader={props.subheader}
					action={props.headerAction}
				/>
			)}
			{props.children && <CardContent className={props.classes?.content}>{props.children}</CardContent>}
			{props.actions && (
				<CardActions>
					<div>{props.actions}</div>
				</CardActions>
			)}
		</Card>
	);
}

export default styled(DetailsSectionWrapper)(({ disablePadding, theme }) => ({
	width: '100%',
	'& > .MuiCardContent-root': {
		padding: !disablePadding ? theme.spacing(2) : 0,
		paddingTop: 0,
		'&:last-child': {
			paddingBottom: !disablePadding ? theme.spacing(2) : 0
		},
		[theme.breakpoints.down('sm')]: {
			padding: !disablePadding ? theme.spacing(1.5) : 0,
			paddingTop: 0,
			'&:last-child': {
				paddingBottom: !disablePadding ? theme.spacing(1.5) : 0
			}
		}
	}
}));
